import { promptConstants } from '../_constants';

export function prompts(state = {}, action) {
  switch (action.type) {
    case promptConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case promptConstants.GETALL_SUCCESS:
      return {
        items: action.prompts
      };
    case promptConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}


export function prompt(state = {}, action) {
  switch (action.type) {
    case promptConstants.REGISTER_SUCCESS:
      return {
        item: action.prompt.data
      };
    case promptConstants.GET_REQUEST:
      return {
        loading: true
      };
    case promptConstants.GET_SUCCESS:
      return {
        item: action.prompt.data
      };
    case promptConstants.GET_FAILURE:
      return {
        error: action.error
      };
    case promptConstants.DELETE_REQUEST:
      return {
        loading: true
      };
    case promptConstants.DELETE_SUCCESS:
      return {
        loading: true
      };
    case promptConstants.DELETE_FAILURE:
      return {
        loading: true
      };
    default:
      return state
  }
}